import apiClient from './apiClient';

/**
 * A assinatura digitalizada do profissional — a imagem que sai acima da linha de assinatura nos
 * documentos dele. A leitura vai com o token de sessão, por isso passa pelo cliente e não por `<img src>`.
 */
class AssinaturaDoProfissionalService {
  private rota(professionalId: number | string): string {
    return `/professionals/${professionalId}/assinatura`;
  }

  /** A imagem como URL de objeto, ou `null` se o profissional ainda não tem assinatura. */
  async verComoUrl(professionalId: number | string): Promise<string | null> {
    try {
      const resposta = await apiClient.getClient().get<Blob>(this.rota(professionalId), { responseType: 'blob' });
      return URL.createObjectURL(resposta.data);
    } catch (err: unknown) {
      const status = (err as { status?: number }).status;
      if (status === 404) return null;
      throw err;
    }
  }

  /** `imagem` é data URL: a escaneada (lida do arquivo) ou a desenhada no quadro. */
  async salvar(professionalId: number | string, imagem: string): Promise<void> {
    await apiClient.put(this.rota(professionalId), { imagem });
  }

  async remover(professionalId: number | string): Promise<void> {
    await apiClient.delete(this.rota(professionalId));
  }
}

export const assinaturaDoProfissionalService = new AssinaturaDoProfissionalService();
export default assinaturaDoProfissionalService;
